<template>
  <div
    @mouseover="mouseEnter = true"
    @mouseleave="mouseEnter = false"
    class="temporary-position"
  >
    <md-card
      class="snew-member-card"
      :class="[{ 'md-elevation-20': mouseEnter }]"
    >
      <div class="card-header">
        <md-avatar class="little-header-avatar">
          <router-link :to="`/s-app/group-page/${member.group.id}`">
            <img src="../../../public/img/little-header-icons/portrait-group-header.png" alt="Group" />
          </router-link>
        </md-avatar>
        <span class="md-title">New group member</span>
        <img src="../../../public/img/group-card-header.png" class="card-header-image" />
      </div>
      <md-card-header>
        <md-avatar>
          <router-link :to="`/s-app/group-page/${member.group.id}`">
            <img :src="getGroupImagePath(member.group)" alt="Group" />
          </router-link>
        </md-avatar>

        <div class="md-title">
          <router-link :to="`/s-app/group-page/${member.group.id}`">
            {{ member.group.name }}
            <md-tooltip v-if="nameTooBig"
            md-direction="bottom"
            class="s-tooltip tp-trade-position"
          >
            {{ member.group.name }} 
          </md-tooltip>
          </router-link>
        </div>
        <div class="md-subhead">
          {{ this.getGroupPrivacy(member.group) }} | {{ member.group.zip }}
        </div>
      </md-card-header>

      <md-card-content class="welcome-content">
        <div class="group-connection">
          <router-link :to="`/s-app/profile-page/${member.user.id}`">
            <SUserAvatar
              :myUser="member.user"
              size="large"
              :isProfileAvatar="false"
            />
          </router-link>
          <md-icon class="ml-2 mr-2">link</md-icon>
          <router-link :to="`/s-app/group-page/${member.group.id}`">
            <md-avatar class="md-large">
              <img :src="getGroupImagePath(member.group)" alt="Group" />
            </md-avatar>
          </router-link>
        </div>

        <div class="group-text">
          <span
            ><router-link :to="`/s-app/group-page/${member.group.id}`"
              ><span class="highlighted-word">{{
                member.group.name
              }}</span></router-link
            >
            group
          </span>
          <span v-if="!isLoggedUser"
            >welcomes
            <router-link :to="`/s-app/profile-page/${member.user.id}`"
              ><span class="highlighted-word">{{
                getUserName(member.user)
              }}</span></router-link
            ></span
          >
          <span v-else>
            welcomes <span class="self-highlighted-word">You</span>
          </span>
        </div>
        <div class="profile-button">
          <SButtonViewProfile
            v-if="!isLoggedUser && !isLoggedUserModerator"
            dataCy="btnViewProfile_result"
            text="View Profile"
            icon="account_circle"
            class="view-profile-button"
            @setAction="mainAction()"
          />
        </div>
        <div
          class="welcome-action-message"
          v-if="!isLoggedUser && isLoggedUserModerator"
        >
          <SButtonMaterial
            class="send-msg-item-btn"
            :md-ripple="false"
            buttonType="button"
            textColor="white"
            iconColor="tertiary"
            iconWithoutText="chat"
            materialClass="dense"
            @button="openChat()"
          />
          <span class="open-chat" @click="openChat()"
            >Send a message to welcome {{ getUserName(member.user) }}</span
          >
        </div>
        <div class="welcome-action-user" v-if="isLoggedUser">
          <div v-if="this.loggedUser.id == member.group.ownerId">
            <md-icon>task_alt</md-icon>
            You created {{ member.group.name }}
          </div>
          <div v-else>
            <md-icon>task_alt</md-icon>
            You joined {{ member.group.name }}
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import moment from "moment";
import UserHelperVue from "@/mixins/UserHelper.vue";
import GroupHelperVue from "@/mixins/GroupHelper.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
import SButtonViewProfile from "@/material-components/molecules/SButtonViewProfile.vue";
export default {
  name: "SNewMemberMaterial",
  props: ["member"],
  mixins: [UserHelperVue, GroupHelperVue],
  data() {
    return {
      mouseEnter: false,
    };
  },
  components: {
    SButtonMaterial,
    SUserAvatar,
    SButtonViewProfile,
  },
  methods: {
    mainAction() {
      console.log("funciona vai");
      this.$router.push(`/s-app/profile-page/${this.member.user.id}`);
    },
    getTimeAgo(time) {
      if (time) {
        return moment(time).fromNow();
      } else {
        return "";
      }
    },
    openChat() {
      this.$emit("openWindowPopup");
    },
  },
  computed: {
    isLoggedUser() {
      return (this.member.user.id === this.loggedUser.id) 
    },
    isLoggedUserModerator() {
      return this.myModeratedGroups.find((group) => {
        return group.groupId === this.member.group.id;
      })
        ? true
        : false;
    },
    nameTooBig() {
      if (this.member.group.name.length > 20) return true;
      return false;
    },
  },
};
</script>

// default card size
<style lang="scss" scoped>
.view-profile-button {
  margin-top: 40px;
}
.temporary-position {
  width: 100%;
  display: flex;
  justify-content: center;
}

.snew-member-card {
  width: 100%;
  min-width: 280px;
  max-width: 100%;
  height: 558px;
  color: $black !important;
  border-radius: 4px;
  border: 1px solid $grey;
}
.welcome-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.welcome-action-message {
  display: flex;
  flex-direction: row;
  margin-left: 1rem;
}
.group-connection {
  display: flex;
  margin-top: 4rem;
  margin-bottom: 2rem;
}
.welcome-action-user,
.group-text {
  word-break: break-all;
}
.group-connection i {
  color: $black !important;
}
.md-large {
  min-width: 100px !important;
  min-height: 100px !important;
}
.highlighted-word,
.self-highlighted-word {
  font-weight: bold;
}
.highlighted-word {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  color: $tertiary;
}
.group-text {
  text-align: center;
  margin-bottom: 5rem;
  color: $black;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0.25px;
}
.md-title a {
  color: $black;
}
.md-title a:hover {
  color: $primary;
}
.welcome-action-user i {
  color: $primary !important;
}
.open-chat {
  cursor: pointer;
  margin-left: -28px;
  color: $tertiary;
  font-size: 16px;
  width: 159px;
  display: flex;
  align-items: center;
  text-align: center;
}
.open-chat:hover {
  color: $primary;
}
.send-msg-item-btn {
  margin-left: -43px;
}
 @media screen and (max-width: 560px) {
  .temporary-position {
    display: flex;
    justify-content: center;
  }
  .md-large {
    width: 80px !important;
    height: 80px !important;
    min-width: 80px !important;
    min-height: 80px !important;
  }
} 
.card-header {
  height: 8%;
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 0 10px;
  border: unset;
}
.card-header .md-avatar {
  min-width: unset;
  height: 24px;
  width: 24px;
  background-color: white;
  z-index: 2;
  margin: 0;
}
.card-header .md-title {
  font-weight: bold;
  margin-left: 10px;
  color: white;
  font-size: 14px;
  z-index: 2;
}
.card-header-image {
  height: 8%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 75%;
}
.little-header-avatar {
  border-radius: 0;
  background-color: #69287B !important;
}
</style>
